 <template>
  <v-dialog v-model="dialog" max-width="450">
    <v-card class="pt-4 pl-2 pr-2">
      <WarningPanel
        :icon="icon"
        :message="message"
        :color="color"
        class="pa-8"
        v-if="!loading"
      ></WarningPanel>

      <v-row class="ma-6" justify="center" v-if="loading">
        <v-progress-circular
          :size="40"
          :width="3"
          color="blue darken-2"
          indeterminate
        ></v-progress-circular>
      </v-row>

      <v-row class="ma-6" justify="center" v-if="loading">
        <span
          class="text-center headline font-weight-bold grey--text text--darken-1"
          justify="center"
          >Por favor, aguarde...</span
        >
      </v-row>

      <v-divider v-if="!loading"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" text @click="close()" v-if="!loading">
          {{ $vuetify.lang.t("$vuetify.FECHAR") }}
        </v-btn>

        <v-btn
          v-if="showAction && !loading"
          color="primary"
          text
          @click="
            actionFunction();
            close();
          "
        >
          {{
            actionButtonName
              ? actionButtonName
              : $vuetify.lang.t("$vuetify.NOVO")
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WarningPanel from "../../components/panels/WarningPanel";
export default {
  components: {
    WarningPanel,
  },
  props: {
    close: Function,
    icon: String,
    message: String,
    dialog: Boolean,
    color: String,
    showAction: Boolean,
    actionFunction: Function,
    actionButtonName: String,
    loading: Boolean,
  },
};
</script>